function initInstagramFooter() {
    let i = 0;
    document.querySelectorAll(".js-footer-instagram").forEach((element) => {
        if (element.splideInstance) {
            element.splideInstance.destroy();
        }

        element.classList.add("js-footer-instagram-" + i);
        
        const splide = new Splide(".js-footer-instagram-" + i, {
            type: "loop",
            drag: "free",
            gap: "53px",
            perPage: 8,
            rewind: false,
            arrows: false,
            pagination: false,
            autoScroll: {
                speed: 0.5,
            },
            breakpoints: {
                767: {
                    perPage: 4,
                    gap: "12px"
                },
                991: {
                    perPage: 5,
                    gap: "12px"
                },
                1198: {
                    perPage: 6,
                    gap: "30px"
                },
                1298: {
                    perPage: 7,
                    gap: "40px"
                },
                1440: {
                    perPage: 8,
                    gap: "53px"
                }
            }
        });

        element.splideInstance = splide;

        if (window.innerWidth > 991) {
            splide.mount();
        } else {
            splide.mount(window.splide.Extensions);
        }
        
        i++;
    });
}

document.addEventListener("DOMContentLoaded", initInstagramFooter);

document.addEventListener('shopify:section:load', initInstagramFooter);
document.addEventListener('shopify:section:select', initInstagramFooter);

function hideMobileMenuContent() {
    if (window.innerWidth < 992) {
        document.querySelectorAll('.js-mobile-menu-content').forEach(menu => {
            menu.style.display = 'none';
        });
    }
}

document.addEventListener("DOMContentLoaded", hideMobileMenuContent);
window.addEventListener("resize", hideMobileMenuContent);

function initMobileMenuToggle() {
    document.querySelectorAll('.js-toggle-mobile-menu').forEach(toggle => {
        toggle.addEventListener('click', function() {
            if (window.innerWidth < 992) {
                this.classList.toggle('active');
                const mobileMenu = this.parentElement.querySelector('.js-mobile-menu-content');
                if (mobileMenu) {
                    if (mobileMenu.style.display === 'flex' || mobileMenu.style.display === '') {
                        let height = mobileMenu.scrollHeight;
                        mobileMenu.style.height = height + 'px';
                        mobileMenu.offsetHeight;
                        mobileMenu.style.transition = 'height 0.3s ease';
                        mobileMenu.style.height = '0';

                        mobileMenu.addEventListener('transitionend', function onTransitionEnd() {
                            mobileMenu.style.display = 'none';
                            mobileMenu.style.height = '';
                            mobileMenu.style.transition = '';
                            mobileMenu.removeEventListener('transitionend', onTransitionEnd);
                        });
                    } else {
                        mobileMenu.style.display = 'flex';
                        let height = mobileMenu.scrollHeight;
                        mobileMenu.style.height = '0';
                        mobileMenu.offsetHeight; 
                        mobileMenu.style.transition = 'height 0.3s ease';
                        mobileMenu.style.height = height + 'px';

                        mobileMenu.addEventListener('transitionend', function onTransitionEnd() {
                            mobileMenu.style.height = '';
                            mobileMenu.style.transition = '';
                            mobileMenu.removeEventListener('transitionend', onTransitionEnd);
                        });
                    }
                }
            }
        });
    });
}

document.addEventListener("DOMContentLoaded", initMobileMenuToggle);
document.addEventListener('shopify:section:load', initMobileMenuToggle);
document.addEventListener('shopify:section:select', initMobileMenuToggle);